/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = All
 *
 * 1 = Active
 *
 * 2 = Closed
 *
 * 3 = Order
 *
 * 4 = Confirmed
 *
 * 5 = Completed
 */
export enum PartsStatus {
  All = 0,
  Active = 1,
  Closed = 2,
  Order = 3,
  Confirmed = 4,
  Completed = 5,
}
